var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_377)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_377)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.797 57.733C54.7965 58.3341 54.5575 58.9105 54.1325 59.3355C53.7074 59.7605 53.1311 59.9995 52.53 60H28.3411C27.74 60 27.1634 59.7615 26.7381 59.3368C26.3127 58.9121 26.0732 58.3359 26.0723 57.7348V22.3302C26.072 22.0322 26.1306 21.7371 26.2445 21.4617C26.3584 21.1863 26.5255 20.9361 26.7362 20.7254C26.947 20.5147 27.1972 20.3476 27.4725 20.2336C27.7479 20.1197 28.043 20.0612 28.3411 20.0614H43.8649L54.797 31.2103V57.733Z",
    fill: "#A6A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0679 30.9194L54.7969 40.2186V31.1452H46.1788C45.8025 31.1495 45.4316 31.0561 45.1022 30.8743L45.0679 30.9194Z",
    fill: "#8D8DB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7968 31.1922H46.1552C45.5541 31.1917 44.9777 30.9527 44.5527 30.5277C44.1277 30.1026 43.8887 29.5263 43.8882 28.9252V20L54.7968 31.1922Z",
    fill: "#B3B3D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8802 52.6373H32.9326V39.6767H47.8802V52.6373ZM41.3358 41.5462V43.815H46.0432V41.5499L41.3358 41.5462ZM41.3358 45.2439V47.4115H46.0432V45.233L41.3358 45.2439ZM41.3358 48.7934V50.8002H46.0432V48.7825L41.3358 48.7934ZM39.4879 50.7894V48.7825H34.7823V50.7894H39.4879ZM39.4879 47.388V45.233H34.7823V47.3988L39.4879 47.388ZM39.4879 43.8385V41.5462H34.7823V43.815L39.4879 43.8385Z",
    fill: "#D9D9E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_377",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_377",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg5);
export default __webpack_public_path__ + "static/media/productivityimg5.64be30936b0f1928057d07c98a4e9422.svg";
export { ForwardRef as ReactComponent };